import { Component, OnInit, OnDestroy } from '@angular/core';
import { Resolution } from 'src/app/shared/models/resolution.model';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { ResolutionListService } from './resolution-list.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ResolutionCreateModalComponent } from '../resolution-create-modal/resolution-create-modal.component';
import Swal from 'sweetalert2';
import { Stock } from 'src/app/shared/models/stock.model';
import { Purpose } from 'src/app/shared/models/purpose.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Response } from 'src/app/shared/models/response.model';
import { ResolutionAsignModalComponent } from '../resolution-asign-modal/resolution-asign-modal.component';

@Component({
  selector: 'app-resolution-list',
  templateUrl: './resolution-list.component.html',
  styleUrls: ['./resolution-list.component.scss']
})
export class ResolutionListComponent implements OnInit, OnDestroy {

  resolutions: Resolution[];
  modalOptions: NgbModalOptions;
  stocks: Stock[];
  purposes: Purpose[];
  filterForm: FormGroup;

  paginationOffset: number;
  paginationLimit : number;
  paginationTotal : number;
  paginationMaxPageSize: number;
  searchFilter: string;

  private getAllSubscription: Subscription = null;
  private deleteSubscription: Subscription = null;
  private createSubscription: Subscription = null;
  private editSubscription  : Subscription = null;

  constructor(private resolutionListService: ResolutionListService,
              private modalService: NgbModal,
              private spinner: NgxSpinnerService,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.paginationOffset      = 1;
    this.paginationLimit       = 10;
    this.paginationTotal       = 0;
    this.paginationMaxPageSize = 5;
    this.searchFilter          = '';

    this.resolutions = [];
    this.stocks      = [];
    this.purposes    = [];

    this.modalOptions = {
      backdrop: 'static',
      backdropClass: 'customBackdrop',
      size: 'lg',
    };

    this.getResolutions();
  }

  ngOnDestroy(): void {
    if (this.getAllSubscription   !== null) { this.getAllSubscription.unsubscribe(); }
    if (this.deleteSubscription   !== null) { this.deleteSubscription.unsubscribe(); }
    if (this.createSubscription   !== null) { this.createSubscription.unsubscribe(); }
    if (this.editSubscription     !== null) { this.editSubscription.unsubscribe();   }
  }

  /**
   * Get resolution list
   */
  getResolutions() {
      this.spinner.show();

      this.getAllSubscription = this.resolutionListService.resolveResolutions(this.searchFilter, this.paginationOffset, this.paginationLimit).subscribe((result: Response) => {
        this.resolutions = result.items;
        this.paginationTotal = result.total;

        this.spinner.hide();
      }, (error) => {
        this.spinner.hide();
        this.toastr.error(error);
        console.error(error);
      });
  }

  /**
   *
   */
  onCreate(): void {
    const modalRef = this.modalService.open(ResolutionCreateModalComponent, this.modalOptions);
    modalRef.result.then((data) => {

      // Se crea el registro
      this.spinner.show();
      this.createSubscription = this.resolutionListService.create(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getResolutions();
      }, (error) => {
        this.spinner.hide();
        this.toastr.error(error);
        console.error('Error in resolution created', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param resolution
   */
  onEdit(resolution: Resolution): void {
    const modalRef = this.modalService.open(ResolutionCreateModalComponent, this.modalOptions);
    modalRef.componentInstance.resolution = resolution;
    modalRef.result.then((data) => {

      this.spinner.show();
      this.editSubscription = this.resolutionListService.update(data).subscribe((result: any) => {
        this.spinner.hide();
        this.getResolutions();
      },
      (error) => {
        this.spinner.hide();
        this.toastr.error(error);
        console.error('Error in resolution modify', error);
      });

    }, (reason) => { });
  }

  /**
   *
   * @param id
   * @param index
   */
  onDelete(id: number, index: number): void {
    Swal.fire({
      title: '¿Seguro que desea eliminar?',
      text: '¡No podrás recuperar el registro seleccionado!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, Bórralo!',
      cancelButtonText: 'No'
    }).then((result) => {
      if (result.value) {
        this.spinner.show();
        this.deleteSubscription = this.resolutionListService.delete(id).subscribe(r => {
          this.resolutions.splice(index, 1);
          this.spinner.hide();
          Swal.fire('Eliminado!', 'El registro ha sido eliminado.', 'success');
        },
        (error) => {
          this.spinner.hide();
          this.toastr.error(error);
          console.error('error to delete item', error);
        });
      }
    });
  }

  /**
   * 
   * @param term 
   */
  onSearch(term: string) {
    this.searchFilter = term;
    this.getResolutions();
  }

  /**
   * 
   */
  onPageChange() {
    console.log('pageChange')
    this.getResolutions();
  }
}
